export const MEDIA = {
    DESKTOP: '@media only screen and (min-width: 769px)',
    TABLET: '@media only screen and (max-width: 1220px)',
    MOBILE: '@media only screen and (max-width: 768px)',
}